import { render, staticRenderFns } from "./ncbpreviewcheck.vue?vue&type=template&id=5f74611d&scoped=true"
import script from "./ncbpreviewcheck.vue?vue&type=script&lang=js"
export * from "./ncbpreviewcheck.vue?vue&type=script&lang=js"
import style0 from "./ncbpreviewcheck.vue?vue&type=style&index=0&id=5f74611d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f74611d",
  null
  
)

export default component.exports